module.exports = __webpack_public_path__ + "img/icon_edit.ed642a39.svg";